// Chaves que existem em pt.js mas faltavam em en.js (mescladas em index.js).
// Mantido flat ("a.b.c": "…") para não reindentar o en.js inteiro.
export const enExtra = {
  "messagesList.metaWindowNotice": "You have 24h to reply after receiving a message, per Meta's policies.",
  "messagesList.header.buttons.integrationBlockedByBot": "The \"Disable Chatbot\" switch below is on and silences all automation for this contact, including this integration.",
  "messagesList.header.buttons.integrationLabel": "Integration",
  "versionControl.title": "An update is available!",
  "versionControl.subtitle": "Click update to get the latest improvements.",
  "versionControl.update": "Update",
  "versionControl.updating": "Updating...",
  "backendErrors.ERR_CAMPAIGN_TEST_NUMBER": "Enter a valid number with country and area code for the test.",
  "backendErrors.ERR_CAMPAIGN_TEST_MESSAGE": "Write message 1 before testing.",
  "backendErrors.ERR_CAMPAIGN_TEST_OFICIAL": "Quick test is not available on the official connection. Save the campaign to a test list instead.",
  "backendErrors.ERR_CAMPAIGN_TEST_TEMPLATE": "Select an approved template before testing on the official connection.",
  "backendErrors.ERR_SMS_ROTA_INDISPONIVEL": "The chosen SMS route is not available. Choose another route in the campaign.",
  "backendErrors.ERR_SMS_ROTA_APOS_ENVIO": "The route cannot be changed on a campaign that has already started sending.",
  "backendErrors.ERR_COMPANY_MANAGED_BY_SUBSCRIPTION": "This company has an active subscription: plan, due date and recurrence are managed by it. Cancel the subscription to edit them.",
  "backendErrors.ERR_PASSWORD_RESET_INVALID_CODE": "Invalid or expired code.",
  "backendErrors.ERR_PASSWORD_RESET_SESSION_EXPIRED": "The reset session expired. Start over.",
  "backendErrors.ERR_PASSWORD_RESET_ALREADY_USED": "This reset request was already used. Start over.",
  "backendErrors.ERR_PASSWORD_RESET_INVALID_TOTP": "Invalid authenticator code.",
  "backendErrors.ERR_PASSWORD_RESET_TOO_MANY_REQUESTS": "Too many requests. Wait a minute and try again.",
  "backendErrors.ERR_PASSWORD_RESET_WEAK_PASSWORD": "The password needs at least 5 characters.",
  "ticketInfo.copyPhone": "Copy phone",
  "ticketInfo.quickMessages": "Quick replies",
  "ticketInfo.phonecopied": "Phone copied to clipboard!",
  "ticketInfo.noPhone": "No phone available to copy",
  "ticketInfo.copyError": "Error copying phone",
  "connections.transferTickets": "Transfer tickets",
  "connections.allOperational": "All connections operational",
  "connections.needsAttention": "connection needs attention",
  "connections.needAttention": "connections need attention",
  "connections.toolTips.oficialError.title": "Connection not registered in the Official API",
  "connections.toolTips.oficialError.content": "The registration in the WhatsApp Official API was not completed. Delete this connection and create it again; if the error persists, check that the Official API service is running",
  "connections.table.channel": "Channel",
  "showTicketLogModal.loading": "Loading…",
  "showTicketLogModal.summary": "{{events}} events · {{access}} views",
  "showTicketLogModal.empty": "No events recorded for this ticket.",
  "showTicketLogModal.showAccess": "Show views",
  "showTicketLogModal.close": "Close",
  "showTicketLogModal.kinds.transfered": "transfers",
  "showTicketLogModal.kinds.pending": "returns to queue",
  "showTicketLogModal.kinds.closed": "closures",
  "showTicketLogModal.kinds.reopen": "reopenings",
  "contacts.toasts.blocked": "Contact blocked.",
  "contacts.toasts.unblocked": "Contact unblocked.",
  "contacts.confirm.blockTitle": "Block {{name}}?",
  "contacts.confirm.blockText": "The contact will not be able to send or receive messages until unblocked.",
  "contacts.confirm.block": "Block",
  "contacts.confirm.unblockTitle": "Unblock {{name}}?",
  "contacts.confirm.unblockText": "The contact can send and receive messages again.",
  "contacts.confirm.unblock": "Unblock",
  "contacts.menu.importSection": "Import",
  "contacts.menu.exportSection": "Export",
  "contacts.menu.importYourPhoneDesc": "Contacts saved on the connected device",
  "contacts.menu.importToExcelDesc": "Map columns and apply tags",
  "contacts.menu.importChats": "From existing chats",
  "contacts.menu.importChatsDesc": "Creates contacts from conversations",
  "contacts.menu.exportSheet": "Export spreadsheet",
  "contacts.menu.exportSheetDesc": "All {{count}} contacts · XLSX",
  "contacts.menu.deleteAll": "Delete all contacts",
  "contacts.bulk.selected": "{{count}} contacts selected",
  "contacts.bulk.selectedAll": "All {{count}} contacts selected",
  "contacts.bulk.addTag": "Add tag",
  "contacts.bulk.assignWallet": "Assign wallet",
  "contacts.bulk.deleteSelected": "Delete selected",
  "contacts.bulk.modeAdd": "Add to tags",
  "contacts.bulk.modeRemove": "Remove from tags",
  "contacts.bulk.noTags": "No tags registered.",
  "contacts.bulk.tagsAdded": "Tags applied to {{count}} contact(s).",
  "contacts.bulk.tagsRemoved": "Tags removed from {{count}} contact(s).",
  "contacts.bulk.walletUser": "Owner",
  "contacts.bulk.walletNone": "No owner (remove wallet)",
  "contacts.bulk.walletQueue": "Queue",
  "contacts.bulk.walletQueueAuto": "Automatic (one of the agent's queues)",
  "contacts.bulk.walletHint": "Replaces the current wallet of the selected contacts.",
  "contacts.bulk.walletAssigned": "Wallet assigned to {{count}} contact(s).",
  "contacts.bulk.walletCleared": "Wallet removed from {{count}} contact(s).",
  "contacts.bulk.cancel": "Cancel",
  "contacts.bulk.apply": "Apply",
  "contacts.pagination.showing": "Showing {{shown}} of {{total}}",
  "contacts.pagination.prev": "Previous page",
  "contacts.pagination.next": "Next page",
  "contacts.confirmDelete.oneTitle": "Delete {{name}}?",
  "contacts.confirmDelete.manyTitle": "Delete {{count}} contacts?",
  "contacts.confirmDelete.allTitle": "Delete all {{count}} contacts?",
  "contacts.confirmDelete.text": "Associated tickets and messages will be lost. This action cannot be undone.",
  "contacts.confirmDelete.confirm": "Delete",
  "contacts.exporting": "Generating spreadsheet…",
  "promptModal.form.agentName": "Agent name",
  "promptModal.form.tone": "Tone of voice",
  "promptModal.form.toneFormal": "Formal",
  "promptModal.form.toneAmigavel": "Friendly",
  "promptModal.form.toneDescontraido": "Casual",
  "promptModal.form.toneTecnico": "Technical",
  "promptModal.form.useEmojis": "Use emojis",
  "promptModal.form.restrictions": "Business restrictions",
  "promptModal.form.restrictionsHelp": "Rules the AI must never break (e.g. do not discuss prices)",
  "promptModal.form.transferInstructions": "When to transfer to a human",
  "promptModal.form.transferInstructionsHelp": "Situations where the AI should hand over to an agent",
  "promptModal.form.transferMessage": "Transfer message",
  "promptModal.form.knowledgeText": "Knowledge base (text)",
  "promptModal.form.model": "Model",
  "promptModal.form.promptBase": "Base prompt",
  "promptModal.form.preview": "System prompt preview",
  "promptModal.tabs.personality": "Personality",
  "promptModal.tabs.knowledge": "Knowledge",
  "promptModal.tabs.advanced": "Advanced",
  "promptModal.files.title": "Knowledge files",
  "promptModal.files.saveFirst": "Save the agent to import files.",
  "promptModal.files.upload": "Import file",
  "promptModal.files.hint": "PDF, TXT or DOCX — up to 20 MB per file, 20 files per agent.",
  "promptModal.files.processing": "Processing",
  "promptModal.files.ready": "Ready",
  "promptModal.files.failed": "Failed",
  "promptModal.files.deleted": "File removed.",
  "promptModal.files.uploaded": "File uploaded. Processing continues in the background.",
  "prompts.table.knowledge": "Knowledge",
  "prompts.table.knowledgeBadge": "Knowledge base",
  "contactModal.form.assignWallet": "Customer wallet",
  "contactModal.form.wallet": "Wallet",
  "contactModal.form.walletPlaceholder": "No owner",
  "contactModal.form.walletQueue": "Wallet queue",
  "contactModal.form.walletQueuePlaceholder": "Select the queue",
  "contactModal.form.birthDate": "Date of birth",
  "contactModal.form.tags": "Tags",
  "contactModal.form.tagsPlaceholder": "Add tag…",
  "contactModal.form.extraEmpty": "No additional information.",
  "contactModal.form.chatbotTitle": "Disable chatbot",
  "contactModal.form.chatbotOn": "The chatbot replies normally.",
  "contactModal.form.chatbotOff": "The chatbot does not reply to this contact.",
  "contactModal.form.campaignsTitle": "Accepts campaigns",
  "contactModal.form.campaignsDesc": "Receives bulk messages",
  "contactModal.form.audioTitle": "Accept audio",
  "contactModal.form.audioDesc": "Allows voice messages from this contact.",
  "contactModal.buttons.addField": "Field",
  "contactModal.buttons.block": "Block",
  "contactModal.buttons.unblock": "Unblock",
  "contactModal.subtitleAdd": "Fill in the details to add a new contact",
  "contactModal.createdAt": "created on",
  "contactModal.photoHint": "The photo comes from the contact's WhatsApp",
  "wallets.wallet": "Wallet",
  "queueModal.form.randomizeImmediate": "Randomize automatically (immediate)",
  "userModal.form.allowSeeMessagesInPendingTickets": "Allow viewing pending tickets",
  "userModal.form.showFlow": "View flows",
  "tagModal.subtitleAdd": "Label for contacts and tickets",
  "tagModal.usedIn": "Used in {{contacts}} contacts and {{tickets}} tickets",
  "tagModal.previewEmpty": "Preview",
  "tagModal.nameShort": "The name must have at least 3 characters.",
  "tagModal.fileTooBig": "File {{name}} is too large. Maximum: 10MB.",
  "tagModal.fileType": "File type {{type}} is not supported.",
  "tagModal.form.namePlaceholder": "E.g. In negotiation",
  "tagModal.form.preview": "Preview",
  "tagModal.form.customColor": "Custom color",
  "tagModal.form.kanbanTitle": "Use as Kanban column",
  "tagModal.form.kanbanDesc": "Tickets with this tag appear in their own lane",
  "tagModal.form.onTimeout": "When time runs out",
  "tagModal.form.highlight": "Highlight card",
  "tagModal.form.moveTo": "Move to {{lane}}",
  "tagModal.form.none": "None",
  "tagModal.form.optional": "optional",
  "tagModal.form.greetingPlaceholder": "Hi {nome}! Your proposal is under review…",
  "tagModal.form.attach": "Attach media",
  "tagModal.form.recurrence": "Recurrence",
  "tagModal.form.recurrenceDesc": "Reapply the tag automatically after a period",
  "tagModal.buttons.delete": "Delete tag",
  "tickets.messageHidden": "Hidden message",
  "tickets.notification.messageHidden": "Hidden message",
  "newTicketModal.subtitle": "Opens a new ticket for the contact",
  "newTicketModal.searchPlaceholder": "Type at least 3 letters to search…",
  "newTicketModal.change": "Change",
  "newTicketModal.queue": "Queue",
  "newTicketModal.connection": "Connection",
  "newTicketModal.selectQueue": "Select a queue",
  "newTicketModal.selectConnection": "Select a connection",
  "newTicketModal.assignTo": "Assign to",
  "newTicketModal.me": "Me",
  "newTicketModal.openTicket": "Ticket #{{id}} open",
  "newTicketModal.openBy": "Handled by",
  "newTicketModal.greetingTitle": "Send greeting on open",
  "newTicketModal.greetingDesc": "Sends a quick reply as the first message",
  "newTicketModal.greetingUses": "Uses the quick reply",
  "newTicketModal.greetingPick": "Choose the quick reply…",
  "contactImport.title": "Import contacts",
  "contactImport.step": "Step {{n}} of {{total}}",
  "contactImport.dropTitle": "Drag the spreadsheet or click to choose",
  "contactImport.dropText": "XLSX, XLS or CSV · first row with the column names",
  "contactImport.invalidFile": "Invalid file. Use .xls, .xlsx or .csv.",
  "contactImport.fileMeta": "{{rows}} rows · {{cols}} columns detected",
  "contactImport.changeFile": "Change file",
  "contactImport.colSheet": "Spreadsheet column",
  "contactImport.colSample": "Example",
  "contactImport.colField": "Field in Pulse",
  "contactImport.skipColumn": "Skip column",
  "contactImport.updateTitle": "Update existing",
  "contactImport.updateDesc": "Same number: overwrites the data",
  "contactImport.extraField": "Extra info",
  "contactImport.validateTitle": "Validate on WhatsApp",
  "contactImport.validateDesc": "Checks the number before creating",
  "contactImport.applyTag": "Apply tag",
  "contactImport.noTag": "None",
  "contactImport.missing": "Map the required fields: {{fields}}",
  "contactImport.invalidLines": "{{count}} row(s) with an invalid number will be skipped.",
  "contactImport.showLines": "Show rows",
  "contactImport.hideLines": "Hide",
  "contactImport.downloadModel": "Download template",
  "contactImport.cancel": "Cancel",
  "contactImport.back": "Back",
  "contactImport.importCount": "Import {{count}} contacts",
  "contactImport.close": "Close",
  "contactImport.startedTitle": "Import running in the background",
  "contactImport.startedText": "{{count}} contacts were sent and are being created in the background ({{ignored}} rows skipped). You will be notified when it finishes; you can close this window.",
  "contactImport.progressTitle": "Importing contacts…",
  "contactImport.progressHint": "You can close this window: the import continues and you will be notified when it finishes.",
  "contactImport.counters": "{{criados}} new · {{ignorados}} already existed · {{invalidos}} invalid",
  "contactImport.doneTitle": "Import finished",
  "contactImport.doneText": "{{criados}} contact(s) created, {{ignorados}} already existed, {{invalidos}} invalid. {{linhas}} spreadsheet row(s) were left out for missing name or number.",
  "contactImport.cancelTitle": "Import cancelled",
  "contactImport.errorTitle": "The import failed",
  "smsModal.title": "Send SMS",
  "smsModal.subtitle": "Text message through the SMS provider",
  "smsModal.balance": "Balance: {{saldo}}",
  "smsModal.balanceAfter": "Balance after sending {{saldo}}",
  "smsModal.message": "Message",
  "smsModal.placeholder": "Type the SMS text…",
  "smsModal.counter": "{{chars}} characters · {{sms}} SMS",
  "smsModal.hint": "Up to 160 characters fit in 1 SMS; above that, every 153 characters count as one more.",
  "smsModal.emptyBody": "Enter the message text.",
  "smsModal.sent": "SMS sent successfully! {{fracoes}} unit(s) charged.",
  "smsModal.cancel": "Cancel",
  "smsModal.send": "Send SMS",
  "contactImportPhone.title": "Import from WhatsApp contacts",
  "contactImportPhone.subtitle": "Brings the contacts saved on the connected device",
  "contactImportPhone.titleChats": "Import from existing chats",
  "contactImportPhone.subtitleChats": "Creates contacts from the connection's conversations",
  "contactImportPhone.choose": "Choose the connection",
  "contactImportPhone.empty": "No WhatsApp QR Code connection registered.",
  "contactImportPhone.connected": "Connected",
  "contactImportPhone.offline": "The connection must be connected.",
  "contactImportPhone.startedChats": "Chat import started in the background. You will be notified when it finishes.",
  "contactImportPhone.noDuplicates": "Existing contacts will not be duplicated.",
  "contactImportPhone.cancel": "Cancel",
  "contactImportPhone.import": "Import contacts",
  "contactImportPhone.started": "Contact list import started in the background. You will be notified when it finishes.",
  "mainDrawer.listItems.callHistorical": "Call history",
  "messagesAPI.textMessage.connection": "Connection",
  "messagesAPI.textMessage.connectionNone": "Select a connection…",
  "messagesAPI.textMessage.template": "Template (used outside the 24h window)",
  "messagesAPI.textMessage.templateNone": "None — let the system choose",
  "messagesAPI.textMessage.templateHelper": "Outside the 24h window Meta only accepts an approved template. Choose which one to use; inside the window the message goes as free text.",
  "messagesAPI.textMessage.templateMediaBadge": "media in header",
  "messagesAPI.textMessage.templateHeaderMediaUrl": "Header media URL",
  "messagesAPI.textMessage.templateHeaderMediaUrlHelper": "This template has media in the header. Enter the public URL of the file (image, video or document); Meta downloads it from that link when sending.",
  "messagesAPI.textMessage.templateParamHelper": "Fixed value or {nome}, {numero}, {email} (contact data)",
  "notifications.messageHidden": "Hidden message",
  "notifications.newMessage": "New message from",
  "triggerFlowModal.title": "Trigger flow",
  "triggerFlowModal.description": "Select a flow to run on this ticket. The ticket status will change to 'chatbot' while it runs.",
  "triggerFlowModal.selectFlow": "Choose a flow",
  "triggerFlowModal.selectedFlow": "Selected flow",
  "triggerFlowModal.flowId": "Flow ID",
  "triggerFlowModal.noFlows": "No active flow found",
  "triggerFlowModal.cancel": "Cancel",
  "triggerFlowModal.trigger": "Trigger flow",
  "triggerFlowModal.triggering": "Triggering...",
  "triggerFlowModal.success": "Flow triggered successfully!",
  "triggerFlowModal.error": "Error triggering flow",
  "quickMessages.selectMessage": "Select quick reply",
  "quickMessages.hasMedia": "With media",
  "quickMessages.global": "Global",
  "quickMessages.noResultsFound": "No quick reply found for your search",
  "quickMessages.noQuickMessages": "No quick reply available",
  "campaignReport.fetchError": "Error fetching report data",
  "campaignReport.backButton": "Back",
  "compaies.table.generateInvoice": "Generate invoice",
  "tags.subtitle": "Labels for contacts and tickets · {{kanban}} used in Kanban",
  "tags.empty": "No tag found",
  "tags.showing": "Showing {{shown}} of {{total}}",
  "tags.filters.all": "All",
  "tags.filters.kanban": "Kanban",
  "tags.filters.unused": "Unused",
  "tags.table.tag": "Tag",
  "tags.table.type": "Type",
  "tags.table.recurrence": "Recurrence",
  "tags.table.createdBy": "Created by",
  "tags.table.kindKanban": "Kanban",
  "tags.table.kindContact": "Contact",
  "tags.table.timeAlert": "Time alert in Kanban",
  "tags.table.seeContacts": "View contacts",
  "tags.table.edit": "Edit",
  "tags.table.delete": "Delete",
  "tags.buttons.deleteAll": "Delete all",
  "tags.confirmDelete.titleBefore": "Delete the tag",
  "tags.confirmDelete.textBefore": "It will be removed from",
  "tags.confirmDelete.contacts": "contacts",
  "tags.confirmDelete.and": "and",
  "tags.confirmDelete.tickets": "tickets",
  "tags.confirmDelete.textAfter": "Contacts are not deleted.",
  "tags.confirmDelete.kanbanWarn": "This tag is a Kanban column — the lane will be removed.",
  "tags.confirmDelete.confirm": "Delete tag",
  "tags.confirmDeleteAll.title": "Delete all {{count}} tags?",
  "tags.confirmDeleteAll.text": "All company tags will be removed from contacts and tickets, including Kanban columns. This action cannot be undone.",
  "tags.confirmDeleteAll.confirm": "Delete all",
  "tags.toasts.deletedAll": "{{count}} tag(s) deleted.",
  "tagContacts.total": "{{count}} contacts",
  "tagContacts.filter": "Filter this list…",
  "tagContacts.empty": "No contact with this tag.",
  "tagContacts.showing": "Showing {{shown}} of {{total}}",
  "tagContacts.seeAll": "See all in Contacts →",
  "tagContacts.remove": "Remove tag",
  "tagContacts.removed": "Tag removed from {{name}}.",
  "settings.settings.options.copyContactPrefix": "Prefix for contact copies",
  "settings.settings.options.copyContactPrefixPlaceholder": "E.g. COPY_",
  "messagesList.header.aiActive": "AI active",
  "messagesList.header.buttons.pauseAI": "Pause AI",
  "messagesList.header.buttons.resumeAI": "Resume AI",
  "messageVariablesPicker.vars.scheduledDate": "Schedule date",
  "messageInput.tooltip.triggerFlow": "Trigger flow",
  "messagesAPIInstructions.fieldTemplateName": "\"templateName\": (optional, official connection) name of the template used outside the 24h window",
  "messagesAPIInstructions.fieldTemplateParams": "\"templateParams\": (optional) array of strings in the order of the variables; accepts {nome}, {numero}, {email}",
  "messagesAPIInstructions.fieldTemplateHeaderMediaUrl": "\"templateHeaderMediaUrl\": (required if the template has media in the header) public http(s) URL of the file",
  "messagesAPIInstructions.fieldTemplateOrderDetails": "\"templateOrderDetails\": (optional, only with templateName) order_details object of the Pix charge template (ORDER_DETAILS): copy-and-paste code, amounts in cents ({ value, offset: 100 }); a format error responds 422 with the violated rule",
  "messagesAPIInstructions.fieldTemplateOrderDetailsExpiration": "\"order.expiration\": (optional) epoch timestamp in seconds, at least 5 min in the future — expires the button on the card; align it with the real validity of the Pix generated at the PSP, which it does not control",
  "messagesAPIInstructions.headerOrigin": "X-Origin (required): name of the calling system, up to 80 characters (e.g. \"Billing ERP\"). Shown as the origin in the API usage report at /reports/api",
  "messagesAPIInstructions.smsFieldNumber": "\"number\": \"5531999999999\" (required) — Brazilian mobile: 55 + area code + number; non-digits are stripped. Landlines (55 + area code + 8 digits starting with 2-5) are rejected with 400, no charge",
  "messagesAPIInstructions.smsFieldBody": "\"body\": \"Your bill is due tomorrow. Pay at {link}\" (required) — the {link} marker is optional and receives the shortened link",
  "messagesAPIInstructions.smsFieldLink": "\"link\": (optional) object; requires {link} in body and vice versa — send url OR whatsappNumber, never both",
  "messagesAPIInstructions.smsFieldLinkUrl": "\"link.url\": \"https://exemplo.com/boleto/123\" — http/https URL",
  "messagesAPIInstructions.smsFieldLinkWhatsapp": "\"link.whatsappNumber\": \"5531988887777\" — digits only; opens a WhatsApp chat",
  "messagesAPIInstructions.smsFieldLinkPrefilled": "\"link.prefilledText\": \"I want to pay\" — (optional) only together with whatsappNumber",
  "messagesAPIInstructions.smsResponseSend": "200: { \"id\": 123, \"status\": \"sent\", \"providerMessageId\": \"…\", \"parts\": 2, \"balance\": 998 } — balance may be null if reading the balance fails; \"debitPending\": true only if the post-send debit fails. 400 { \"error\": \"…\" }: X-Origin missing, invalid field, landline number (\"Número fixo não recebe SMS\") or not a mobile, or insufficient balance",
  "messagesAPIInstructions.smsResponseStatus": "200: { \"id\", \"number\", \"status\": \"pending|sent|delivered|failed\", \"failureReason\", \"origin\", \"parts\", \"sentAt\", \"deliveredAt\" } — with no provider confirmation after 24h (or the company's configured deadline), \"sent\" becomes \"failed\" with failureReason \"Sem confirmação de entrega do provedor de SMS em 24h\"; if the provider confirms later it goes back to \"delivered\". 404 { \"error\": \"SMS não encontrado.\" }",
  "messagesAPIInstructions.smsResponseBalance": "200: { \"balance\": 998 } — credits = SMS parts (up to 160 characters = 1 part; above that, 153 per part)",
  "messagesAPIInstructions.responseText": "200 (official connection): { \"message\": \"Mensagem enviada com sucesso\", \"companyId\": 1, \"ticketId\": 215, \"messageId\": 4821, \"wid\": \"wamid.…\", \"status\": \"accepted\" } — accepted = accepted by Meta; delivery is asynchronous, query GET /api/messages/{messageId}/status. The message text did not change and does not guarantee delivery. \"warning\" { code, category, reason, action, link, reasonOriginal } only appears if the connection has an account issue. QR Code connection (Baileys): { \"message\": \"Mensagem enviada a fila de transmissão com sucesso\", \"companyId\", \"schedule\", \"filaId\" }, with no messageId (the message is created later, by the queue). If Meta refuses right away, an HTTP error (not 200) comes back with the translated reason in \"error\". Types: messageId = number | null and wid = string | null. null means the message was accepted but has no queryable record yet: keep the ticketId and do not query the status (only query when messageId is not null).",
  "messagesAPIInstructions.responseMedia": "200 (official connection): { \"status\": \"SUCCESS\", \"messageId\": 4822, \"messageIds\": [4822], \"wid\": \"wamid.…\" } — SUCCESS is the old contract and only means accepted by Meta; delivery is asynchronous. messageId = first file; messageIds = one id per file, in sending order; query each one at GET /api/messages/{messageId}/status. \"warning\" only with an account issue on the connection. QR Code connection (Baileys): { \"status\": \"SUCCESS\" }, with no messageId. Types: messageId = number | null, messageIds = list of number | null, wid = string | null. null = accepted, with no queryable record: skip the nulls and do not query their status.",
  "messagesAPIInstructions.statusResponse": "200: { \"messageId\": 4821, \"wid\": \"wamid.…\", \"status\": \"accepted|sent|delivered|read|failed\", \"ack\": -1, \"failure\": { \"code\": 131042, \"category\": \"conta\", \"reason\": \"…\", \"action\": \"…\", \"link\": \"…\", \"reasonOriginal\": \"…\" } } — failure is null while the message has not failed (ack: 0/1 sent, 2 delivered, 3 read, -1 = failed). Meta confirms delivery later: the message may stay in accepted/sent for a while. Nothing is resent automatically. 404 { \"error\": \"ERR_NO_MESSAGE_FOUND\" }: id does not exist, belongs to another company or to another connection (the token only sees messages sent by its own connection). 402 ERR_LICENSE_EXPIRED: expired license",
  "whatsappModalRel.form.isOficial": "Ticket report",
  "whatsappModalRel.form.ticketId": "Ticket ID",
  "whatsappModalRel.form.client": "Customer",
  "whatsappModalRel.form.number": "Number",
  "whatsappModalRel.form.agent": "Agent",
  "whatsappModalRel.form.date": "Date",
  "whatsappModalRel.form.lastMessage": "Last message",
  "whatsappModalRel.form.fullReport": "The full report was attached above",
  "whatsappModalRel.form.resolveAndTriggerIntegration": "Resolve and trigger integration",
  "whatsappModalRel.form.elementNotFoundForExport": "Element not found for export.",
  "whatsappModalRel.form.reportFilename": "ticket_report",
  "chatMessages.deletedAdminShort": "Visible to admin",
  "chatMessages.copy": "Copy",
  "chatMessages.copied": "Message copied.",
  "chatMessages.react": "React",
  "chatMessages.linkTicket": "Link ticket",
  "chatMessages.ticketNumber": "Ticket no.",
  "chatMessages.ticketNotFound": "Ticket not found.",
  "chatMessages.attachTicket": "Attach to message",
  "chatMessages.openTicket": "Open ticket",
  "chatMessages.editTimeLeft": "{{min}} min left to edit",
  "chatMessages.editHint": "The message will be marked as \"edited\" for everyone.",
  "chatMessages.editedLabel": "edited",
  "chatMessages.forwardedLabel": "Forwarded",
  "chatMessages.forwardSubtitle": "Choose one or more conversations",
  "chatMessages.forwardedTo": "Forwarded to {{count}} conversation(s).",
  "chatMessages.selectedCount": "{{count}} selected",
  "chatMessages.deleteTitle": "Delete message?",
  "chatMessages.deleteText": "It will be replaced by \"This message was deleted\" for everyone. Administrators can still see the original content.",
  "chatMessages.deleteConfirm": "Delete",
  "chatMessages.message": "Message",
  "chatMessages.document": "Document",
  "chatMessages.readyToSend": "ready to send",
  "chatMessages.placeholderGroup": "Message to the group…",
  "chatMessages.placeholderDm": "Message…",
  "chatIndex.markAllRead": "Mark all as read",
  "chatIndex.filters.all": "All",
  "chatIndex.filters.unread": "Unread",
  "chatIndex.filters.groups": "Groups",
  "chatIndex.selectChat": "Choose a conversation or create a new one",
  "chatIndex.participants": "{{count}} participants",
  "chatIndex.online": "{{count}} online",
  "chatIndex.onlineNow": "Online",
  "chatIndex.offline": "Offline",
  "chatIndex.searchInChat": "Search in conversation",
  "chatIndex.searchInChatPlaceholder": "Search loaded messages…",
  "chatIndex.menu.section": "Conversation",
  "chatIndex.menu.details": "Group details",
  "chatIndex.menu.detailsDm": "Conversation details",
  "chatIndex.menu.edit": "Edit group",
  "chatIndex.menu.mute": "Mute",
  "chatIndex.menu.unmute": "Unmute notifications",
  "chatIndex.menu.markRead": "Mark as read",
  "chatIndex.menu.leave": "Leave group",
  "chatIndex.menu.delete": "Delete conversation",
  "chatIndex.info.createdBy": "Created by {{name}}",
  "chatIndex.info.members": "Participants · {{count}}",
  "chatIndex.info.add": "Add",
  "chatIndex.deleteChat.title": "Delete this conversation?",
  "chatIndex.deleteChat.groupBefore": "The group",
  "chatIndex.deleteChat.dmBefore": "The conversation with",
  "chatIndex.deleteChat.middle": "and its",
  "chatIndex.deleteChat.messages": "{{count}} messages",
  "chatIndex.deleteChat.after": "will be removed for all {{count}} participants.",
  "chatIndex.deleteChat.confirm": "Delete for everyone",
  "chatIndex.leave.title": "Leave {{name}}?",
  "chatIndex.leave.text": "You will stop receiving messages from this group. An administrator can add you again.",
  "chatIndex.leave.confirm": "Leave group",
  "chatIndex.toasts.chatDeleted": "Conversation deleted.",
  "chatIndex.toasts.left": "You left the group.",
  "chatIndex.toasts.muted": "Conversation muted.",
  "chatIndex.toasts.unmuted": "Notifications resumed.",
  "chatIndex.toasts.mentioned": "{{name}} mentioned you in {{chat}}. Click to open.",
  "chatIndex.modal.subtitle": "Chat with a colleague or create a team group",
  "chatIndex.modal.subtitleDirect": "Choose a colleague to chat with",
  "chatIndex.modal.editSubtitle": "Group name and participants",
  "chatIndex.modal.direct": "Direct",
  "chatIndex.modal.group": "Group",
  "chatIndex.modal.namePlaceholder": "E.g. Support L1 — afternoon shift",
  "chatIndex.modal.nameRequired": "Enter the group name.",
  "chatIndex.modal.membersRequired": "Choose at least one participant.",
  "chatIndex.modal.members": "Participants",
  "chatIndex.modal.selected": "{{count}} selected",
  "chatIndex.modal.addQueue": "Add the whole {{queue}} queue",
  "chatIndex.modal.searchPerson": "Search person…",
  "chatIndex.modal.onlineSection": "Online",
  "chatIndex.modal.offlineSection": "Offline",
  "chatIndex.modal.existing": "Existing conversation",
  "chatIndex.modal.directHint": "If a conversation with this person already exists, it will be opened.",
  "twoFactor.setup.title": "Two-Factor Authentication (2FA)",
  "twoFactor.setup.description": "Add an extra layer of security to your account using an authenticator app such as Google Authenticator or Authy.",
  "twoFactor.setup.enable": "Enable 2FA",
  "twoFactor.setup.manage": "Manage 2FA",
  "twoFactor.setup.statusEnabled": "Two-factor authentication is enabled on your account.",
  "twoFactor.setup.statusDisabled": "Two-factor authentication is not enabled.",
  "twoFactor.setup.activate": "Activate",
  "twoFactor.setup.deactivate": "Disable 2FA",
  "twoFactor.setup.adminDeactivate": "Disable 2FA (Admin)",
  "twoFactor.setup.passwordConfirm": "Confirm your password",
  "twoFactor.setup.scanQR": "Scan the QR code below with your authenticator app:",
  "twoFactor.setup.manualEntry": "Or enter the code manually:",
  "twoFactor.setup.verifyCode": "Verification code",
  "twoFactor.setup.verifyAndActivate": "Verify and activate",
  "twoFactor.setup.invalidCode": "Invalid code. Enter the 6 digits from your app.",
  "twoFactor.setup.recoveryTitle": "Recovery codes",
  "twoFactor.setup.recoveryWarning": "Keep these codes in a safe place. Each code can be used only once. These codes will not be shown again.",
  "twoFactor.setup.copyCodes": "Copy codes",
  "twoFactor.setup.codesCopied": "Codes copied!",
  "twoFactor.setup.confirmSaved": "I confirm I have saved the recovery codes",
  "twoFactor.setup.done": "Done",
  "twoFactor.setup.close": "Close",
  "twoFactor.setup.disabled": "2FA disabled successfully",
  "twoFactor.setup.mandatoryMessage": "Your organization requires two-factor authentication. Set it up now to continue.",
  "twoFactor.setup.setupComplete": "2FA set up successfully! You will be redirected automatically.",
  "twoFactor.policy.label": "2FA policy",
  "twoFactor.policy.optional": "Optional",
  "twoFactor.policy.mandatory": "Mandatory",
  "twoFactor.policy.disabled": "Disabled",
  "scheduleModal.failure.title": "Last send failed",
  "scheduleModal.failure.unknown": "The send failed, but no reason was recorded.",
  "schedules.failureTooltip": "Reason: {{reason}}",
  "scheduleModal.template.subtitle": "Choose the template Meta will deliver at the scheduled time",
  "scheduleModal.template.title": "Approved template (WhatsApp Official)",
  "scheduleModal.template.select": "Choose template",
  "scheduleModal.template.placeholder": "No template selected",
  "scheduleModal.template.none": "No template",
  "scheduleModal.template.paramLabel": "Value for {{token}}",
  "scheduleModal.template.paramHelper": "Fixed text or {nome}, {numero}, {email} - resolved from the contact at send time",
  "scheduleModal.template.preview": "Preview",
  "scheduleModal.template.incomplete": "Fill in every template variable.",
  "scheduleModal.template.windowHint": "Without a template, the message only goes through if the contact wrote in the last 24 hours. Outside that window Meta requires an approved template.",
  "scheduleModal.template.emptySync": "No approved template on this connection. Sync the templates on the Connections screen.",
  "scheduleModal.template.emptyIneligible": "This connection has {{count}} approved template(s), but none can be used here: they all require header media or a button with a variable URL.",
  "scheduleModal.template.mixed": "This template mixes numbered and named variables in the same body. Fix it on Meta and sync again.",
  "plans.form.amountYearly": "Yearly price",
  "plans.grid.perMonth": "/month",
  "plans.grid.perYear": "/year",
  "settings.settings.payments.mpPublicKey": "Mercado Pago · Public Key",
  "settings.settings.payments.pixDiscount": "Pix discount (%)",
  "settings.settings.options.updateSuccess": "Operation updated successfully.",
  "subscription.checkout.titleNew": "Subscribe to plan",
  "subscription.checkout.titleInvoice": "Pay invoice",
  "subscription.checkout.subtitleNew": "{{plan}} · cycle starts today, {{date}}",
  "subscription.checkout.subtitleInvoice": "Invoice of {{date}} · {{value}}",
  "subscription.checkout.stepPlan": "Plan",
  "subscription.checkout.stepPayment": "Payment",
  "subscription.checkout.period": "Billing period",
  "subscription.checkout.invoicePeriod": "Invoice period",
  "subscription.checkout.monthly": "Monthly",
  "subscription.checkout.yearly": "Yearly",
  "subscription.checkout.perMonth": "/month",
  "subscription.checkout.perYear": "/year",
  "subscription.checkout.chargedOnDay": "Charged every month on day {{day}}",
  "subscription.checkout.approxMonthly": "≈ {{value}} per month",
  "subscription.checkout.saveOneMonth": "Save 1 month",
  "subscription.checkout.saveMonths": "Save {{count}} months",
  "subscription.checkout.planSummary": "Plan summary",
  "subscription.checkout.selected": "Selected",
  "subscription.checkout.users": "Users",
  "subscription.checkout.connections": "Connections",
  "subscription.checkout.queues": "Queues",
  "subscription.checkout.lineMonthly": "{{plan}} · monthly",
  "subscription.checkout.lineYearly": "{{plan}} · yearly",
  "subscription.checkout.installmentsRow": "Card installments",
  "subscription.checkout.installmentsUpTo": "up to {{label}}",
  "subscription.checkout.installmentLabel": "{{n}}x of {{value}}",
  "subscription.checkout.pixDiscountRow": "Pix discount ({{percent}}%)",
  "subscription.checkout.total": "Cycle total",
  "subscription.checkout.totalInvoice": "Invoice total",
  "subscription.checkout.cycleCardMonthly": "Renews automatically on {{date}} with the same card",
  "subscription.checkout.cycleCardYearly": "Valid until {{date}}. We will remind you 5 days before renewal.",
  "subscription.checkout.cyclePix": "Next invoice on {{date}}. Pix does not renew automatically: we will remind you 5 days before.",
  "subscription.checkout.tabsLabel": "Payment method",
  "subscription.checkout.tabCard": "Card",
  "subscription.checkout.tabPix": "Pix",
  "subscription.checkout.secure": "Card details go straight to Mercado Pago. Pulse never stores the number.",
  "subscription.checkout.subscribe": "Subscribe · {{value}}",
  "subscription.checkout.payInvoice": "Pay · {{value}}",
  "subscription.checkout.generatePix": "Generate Pix · {{value}}",
  "subscription.checkout.terms": "By subscribing you agree to automatic renewal every cycle. Cancel anytime in Subscription › Current plan.",
  "subscription.checkout.pixHint": "Generate the code and pay in your bank app. Confirmation arrives within seconds.",
  "subscription.checkout.qrAlt": "Pix QR code",
  "subscription.checkout.waitingPix": "Waiting for payment. This screen updates on its own once the Pix is confirmed.",
  "subscription.checkout.waitingCard": "Payment under review by Mercado Pago. This screen updates on its own once it is confirmed.",
  "subscription.checkout.waitingRecurring": "Waiting for Mercado Pago to confirm. The subscription activates on its own in a moment.",
  "subscription.checkout.alreadyPaidQuestion": "Paid and nothing changed in 2 minutes?",
  "subscription.checkout.alreadyPaid": "I already paid",
  "subscription.card.actions.checkPayment": "I already paid · check payment",
  "auth.dueDate.expired": "Your subscription expired on {{date}}. Settle the payment to use the system again.",
  "subscription.checkout.stillPending": "We have not received the confirmation yet. Please wait a little longer.",
  "subscription.checkout.paid": "Payment confirmed. Your subscription is active!",
  "subscription.checkout.cardRejected": "Card declined. Check the details or use another card.",
  "subscription.checkout.cardUnavailable": "Card payment is unavailable right now. Use Pix.",
  "subscription.checkout.cardLoadError": "Could not load the card form. Use Pix or try again.",
  "subscription.checkout.loadError": "Could not load the checkout.",
  "subscription.checkout.retry": "Try again",
  "subscription.checkout.noPrice": "This plan has no price set yet. Please contact support.",
  "subscription.checkout.pageTitle": "Subscription",
  "subscription.checkout.licenseLabel": "License period",
  "subscription.checkout.licenseDueToday": "Your license expires today!",
  "subscription.checkout.licenseDueIn": "Your license expires in {{days}} days.",
  "subscription.checkout.licenseExpired": "Your license has expired. Pay to keep using the system.",
  "subscription.checkout.billingEmail": "Billing e-mail",
  "subscription.checkout.adminOnlyNotice": "Access is suspended until the subscription is paid. Ask your company administrator to settle it in Subscription.",
  "subscription.page.title": "My subscription",
  "subscription.page.smsBalance": "SMS credit balance:",
  "subscription.checkout.subscribeNow": "Subscribe now",
  "backendErrors.ERR_SUB_ALREADY_ACTIVE": "Your company already has an active subscription.",
  "backendErrors.ERR_SUB_PENDING_IN_PROGRESS": "A subscription checkout is already in progress. Wait a moment and try again.",
  "backendErrors.ERR_SUB_INVOICE_JUST_PAID": "This invoice was just paid. Refresh the page.",
  "backendErrors.ERR_SUB_CARD_REJECTED": "Card declined. Check the details or use another card.",
  "backendErrors.ERR_SUB_INVALID_COMBINATION": "This combination of period and payment method is not available for the plan.",
  "backendErrors.ERR_SUB_INVALID_PERIOD": "Invalid period for this plan.",
  "backendErrors.ERR_SUB_CARD_TOKEN_REQUIRED": "Fill in the card details.",
  "backendErrors.ERR_SUB_PAYMENT_METHOD_REQUIRED": "We could not identify the card brand. Check the number.",
  "backendErrors.ERR_SUB_ALREADY_RECURRING": "This subscription already has automatic card billing. Wait for the next attempt or pay with Pix.",
  "backendErrors.ERR_SUB_PREVIOUS_PREAPPROVAL": "Could not close the previous attempt at Mercado Pago. Try again shortly.",
  "backendErrors.ERR_SUB_NOT_FOUND": "Subscription not found.",
  "backendErrors.ERR_SUB_NO_CARD": "This subscription has no card on file.",
  "backendErrors.ERR_SUB_NO_RECURRING": "This subscription has no automatic card billing.",
  "backendErrors.ERR_SUB_SAME_PERIOD": "The subscription is already on this period.",
  "backendErrors.ERR_SUB_SAME_PLAN": "The subscription is already on this plan.",
  "backendErrors.ERR_SUB_UPGRADE_PENDING": "An upgrade is awaiting payment. Pay its invoice before another change.",
  "backendErrors.ERR_SUB_NEXT_CYCLE_INVOICE_OPEN": "The next cycle invoice has already been issued. Pay it before changing the subscription.",
  "backendErrors.ERR_SUB_INVALID_ACTION": "Invalid subscription action.",
  "backendErrors.ERR_INVOICE_NOT_FOUND": "Invoice not found.",
  "backendErrors.ERR_INVOICE_NOT_OPEN": "This invoice is no longer open.",
  "backendErrors.ERR_NO_PLAN_FOUND": "Your company has no plan set. Please contact support.",
  "subscription.card.title": "Current plan",
  "subscription.card.status.active": "Active",
  "subscription.card.status.pastDue": "Past due",
  "subscription.card.status.canceled": "Canceled, access until {{date}}",
  "subscription.card.status.pending": "Awaiting payment",
  "subscription.card.renewal.auto": "Automatic",
  "subscription.card.renewal.pix": "Manual (Pix)",
  "subscription.card.renewal.savedCard": "On the card, with a notice 5 days before",
  "subscription.card.renewal.none": "Does not renew",
  "subscription.card.methodPix": "Pix",
  "subscription.card.methodRecurring": "recurring card",
  "subscription.card.methodInstallments": "{{n}} card installments",
  "subscription.card.methodCardOnce": "card, single payment",
  "subscription.card.plan": "Plan",
  "subscription.card.periodicity": "Billing period",
  "subscription.card.cycle": "Current cycle",
  "subscription.card.nextCharge": "Next charge",
  "subscription.card.paymentMethod": "Payment method",
  "subscription.card.renewal.label": "Renewal",
  "subscription.card.accessUntil": "Access until",
  "subscription.card.cycleRange": "{{start}} → {{end}}",
  "subscription.card.nextChargeValue": "{{date}} · {{value}}",
  "subscription.card.cardMasked": "{{brand}} •••• {{last4}}",
  "subscription.card.cardOnFile": "Card",
  "subscription.card.pendingPlan": "Switches to {{plan}} on {{date}}",
  "subscription.card.pendingPeriod": "Switches to {{period}} on {{date}}",
  "subscription.card.actions.changePlan": "Change plan",
  "subscription.card.actions.toMonthly": "Switch to monthly",
  "subscription.card.actions.toYearly": "Switch to yearly",
  "subscription.card.actions.changeCard": "Change card",
  "subscription.card.actions.cancel": "Cancel subscription",
  "subscription.card.actions.payInvoice": "Pay invoice · {{value}}",
  "subscription.card.actions.subscribe": "Subscribe to a plan",
  "subscription.card.rulesNote": "Billing period changes and downgrades take effect next cycle. Upgrades charge only the difference for the remaining days and apply once paid. Canceling keeps access until {{date}}.",
  "subscription.card.canceledNote": "Subscription canceled. Access continues until {{date}} and nothing else will be charged.",
  "subscription.card.pendingNote": "Waiting for the subscription payment to be confirmed.",
  "subscription.card.pastDueNote": "The renewal was not paid. Pay the invoice to keep your access.",
  "subscription.card.upgradePendingNote": "Upgrade awaiting payment ({{value}}). The new plan applies once paid.",
  "subscription.card.empty": "Your company has no subscription yet. Subscribe with card or Pix.",
  "subscription.card.loadError": "Could not load the subscription.",
  "subscription.card.renewalFailed": "We could not charge your subscription renewal. Pay the invoice in Subscription to keep your access.",
  "subscription.manage.cancelTitle": "Cancel subscription",
  "subscription.manage.cancelBody": "The subscription will not renew. You keep using the system normally until {{date}}; after that, access is suspended.",
  "subscription.manage.cancelInvoices": "Open invoices of this subscription are canceled too.",
  "subscription.manage.cancelConfirm": "Cancel subscription",
  "subscription.manage.cancelKeep": "Keep subscription",
  "subscription.manage.canceled": "Subscription canceled. Access continues until {{date}}.",
  "subscription.manage.periodTitle": "Change billing period",
  "subscription.manage.periodSubtitle": "{{plan}} · applies from the next cycle",
  "subscription.manage.periodNoticePix": "Applies next cycle, from {{date}}. The next Pix invoice already comes in the new period.",
  "subscription.manage.periodNoticeCardYearly": "Applies next cycle, from {{date}}. The first yearly charge is made at checkout (card or Pix).",
  "subscription.manage.periodNoticeCardMonthly": "Applies next cycle, from {{date}}. The first monthly charge is made at checkout (card or Pix).",
  "subscription.manage.periodUndo": "The scheduled change is undone and the subscription stays as it is.",
  "subscription.manage.periodConfirm": "Confirm change",
  "subscription.manage.periodChanged": "Billing period change scheduled for {{date}}.",
  "subscription.manage.periodUndone": "Billing period change undone.",
  "subscription.manage.cardTitle": "Change card",
  "subscription.manage.cardSubtitle": "Nothing is charged now",
  "subscription.manage.cardNotice": "The new card is used for the next charges. The amount in the form is just the current cycle price, to validate the card: nothing is charged now.",
  "subscription.manage.cardSubmit": "Save card",
  "subscription.manage.cardChanged": "Card updated.",
  "subscription.manage.planTitle": "Change plan",
  "subscription.manage.planSubtitle": "Prices in the current period ({{period}})",
  "subscription.manage.planListLabel": "Available plans",
  "subscription.manage.planCurrent": "Current",
  "subscription.manage.planScheduled": "Scheduled",
  "subscription.manage.planLimits": "{{users}} users · {{connections}} connections · {{queues}} queues",
  "subscription.manage.planUpgrade": "Upgrade: we charge now only the prorated difference for the days left in the cycle. The new plan applies once the payment is confirmed.",
  "subscription.manage.planUpgradeCard": "It is charged to the card {{card}}.",
  "subscription.manage.planUpgradePix": "We will generate a Pix for the difference.",
  "subscription.manage.planDowngrade": "Downgrade: applies from the next cycle, on {{date}}. Until then you stay on the current plan.",
  "subscription.manage.planUndo": "The scheduled downgrade is undone; you stay on the current plan.",
  "subscription.manage.planConfirm": "Confirm change",
  "subscription.manage.planNoOthers": "No other plans are available in this period.",
  "subscription.manage.planDowngradeScheduled": "Downgrade scheduled for {{date}}.",
  "subscription.manage.planUndone": "Downgrade undone.",
  "subscription.manage.planChanged": "Plan changed.",
  "subscription.manage.planUpgradePaid": "Upgrade paid. The new plan is already active.",
  "subscription.manage.planUpgradeReview": "Upgrade payment under review. The plan changes once it is approved.",
  "subscription.manage.planUpgradeOpen": "We could not charge the upgrade to the card. Pay the upgrade invoice in the invoice list.",
  "subscription.manage.planPixTitle": "Pay the upgrade with Pix",
  "subscription.manage.planPixValue": "Prorated difference: {{value}}",
  "subscription.manage.close": "Close",
  "invoices.status.paid": "Paid",
  "invoices.status.overdue": "Overdue",
  "invoices.status.open": "Open",
  "invoices.status.canceled": "Canceled",
  "invoices.table.period": "Period",
  "invoices.table.method": "Method",
  "invoices.table.pay": "Pay",
  "subscription.manage.cardUnavailable": "Changing the card is unavailable right now. Please try again later.",
  "invoices.table.status": "Status",
  "metaErrors.notDelivered": "Not delivered",
  "metaErrors.generic": "WhatsApp refused to send this message",
  "metaErrors.showDetails": "Show details",
  "metaErrors.hideDetails": "Hide details",
  "metaErrors.technicalCode": "Technical code",
  "metaErrors.markResolved": "I fixed it",
  "metaErrors.markResolvedTitle": "Mark the issue as resolved?",
  "metaErrors.markResolvedBody": "The account issue notice is removed from this connection. If Meta refuses sends again, it comes back on its own.",
  "metaErrors.markResolvedConfirm": "Yes, I fixed it",
  "metaErrors.fixAt": "Fix in Meta Business",
  "metaErrors.bannerTitle": "Official WhatsApp account issue",
  "metaErrors.bannerDismiss": "Dismiss account issue notice",
  "metaErrors.badge.131042": "Payment pending at Meta",
  "metaErrors.badge.131031": "Account restricted by Meta",
  "metaErrors.badge.131045": "Number not registered",
  "metaErrors.badge.133010": "Number not registered",
  "metaErrors.badge.368": "Account restricted by Meta",
  "metaErrors.badge.130497": "Sending restricted by country",
  "metaErrors.badge.134011": "Payment terms pending",
  "metaErrors.badge.190": "Meta access expired",
  "metaErrors.badge.default": "Account issue",
  "metaErrors.accountToast": "Problem with the WhatsApp account: {{titulo}}",
  "metaErrors.composerWarning": "Problem with this connection's account: {{titulo}}. You can still send, but messages may not be delivered.",
  "metaErrors.failureLine": "Not delivered: {{titulo}}.",
  "metaErrors.131042.title": "The WhatsApp Business account has a pending payment with Meta",
  "metaErrors.131042.action": "Settle it in Meta Business to resume sending",
  "metaErrors.131031.title": "The WhatsApp Business account was restricted or blocked by Meta",
  "metaErrors.131031.action": "Open Meta Business Manager and follow the verification steps",
  "metaErrors.131045.title": "The phone number is not registered on the official API",
  "metaErrors.131045.action": "Register the number again in the Official WhatsApp connection",
  "metaErrors.133010.title": "The phone number is not registered on the official API",
  "metaErrors.133010.action": "Register the number again in the Official WhatsApp connection",
  "metaErrors.368.title": "Meta restricted the account for violating its policies",
  "metaErrors.368.action": "Check the details in Meta Business Manager and request a review",
  "metaErrors.130497.title": "The account is restricted from messaging contacts in some countries",
  "metaErrors.130497.action": "Only message contacts in allowed countries, or contact Meta",
  "metaErrors.134011.title": "Meta's payment terms are waiting to be accepted",
  "metaErrors.134011.action": "Accept the payment terms in Meta Business to resume sending",
  "metaErrors.190.title": "The connection's access to Meta has expired or is invalid",
  "metaErrors.190.action": "Reconnect Official WhatsApp under Connections to get a new access token",
  "metaErrors.131047.title": "More than 24 hours have passed since the customer's last reply",
  "metaErrors.131047.action": "Send an approved template to reopen the conversation",
  "metaErrors.131026.title": "The message could not be delivered: the contact may not have WhatsApp, may be on an outdated app version or may not have accepted WhatsApp's terms",
  "metaErrors.131026.action": "Confirm the number with the contact and ask them to update WhatsApp",
  "metaErrors.131050.title": "The contact opted out of marketing messages",
  "metaErrors.131050.action": "Do not send marketing to this contact; service messages are still allowed",
  "metaErrors.130403.title": "The contact has blocked your business number",
  "metaErrors.130403.action": "You cannot message this contact until they unblock you",
  "metaErrors.131049.title": "Meta limited marketing messages to this contact",
  "metaErrors.131049.action": "Try again later or send a non-promotional message",
  "metaErrors.131021.title": "The message was sent to the business's own number",
  "metaErrors.131021.action": "Enter the customer's number as the recipient",
  "metaErrors.132001.title": "The template does not exist or is not approved for this language",
  "metaErrors.132001.action": "Check the template name and language and that it is approved in Meta",
  "metaErrors.132015.title": "The template is paused due to low quality",
  "metaErrors.132015.action": "Edit the template in Meta or use another approved one",
  "metaErrors.132016.title": "The template was disabled due to low quality",
  "metaErrors.132016.action": "Create a new template and submit it for approval",
  "metaErrors.category.conta.title": "Meta refused the send because of an issue with the account or connection",
  "metaErrors.category.conta.action": "Try again in a few minutes; if it persists, check the connection and the account in Meta Business",
  "metaErrors.category.contato.title": "The message could not be delivered to this contact",
  "metaErrors.category.contato.action": "Check the number and whether the contact can receive this message",
  "metaErrors.category.janela.title": "The conversation's 24-hour window is closed",
  "metaErrors.category.janela.action": "Send an approved template to reopen the conversation",
  "metaErrors.category.template.title": "Meta refused to send the template",
  "metaErrors.category.template.action": "Check the variables and the template status in Meta",
  "metaErrors.category.limite.title": "Meta limited sending because of volume or quality",
  "metaErrors.category.limite.action": "Wait a little and slow down the sending pace",
  "metaErrors.category.midia.title": "Meta did not accept the file or media type sent",
  "metaErrors.category.midia.action": "Send a file in a format and size supported by WhatsApp",
  "metaErrors.unknown.title": "Meta did not deliver the message for an uncatalogued reason",
  "metaErrors.unknown.action": "See Meta's original text in the technical details",
  "backendErrors.ERR_PROMPT_WHATSAPP_REQUIRED": "Choose the agent's connection.",
  "backendErrors.ERR_PROMPT_QUEUE_OR_PREQUEUE_REQUIRED": "Choose at least one queue or check “Also answer before distribution”.",
  "backendErrors.ERR_PROMPT_QUEUE_NOT_IN_WHATSAPP": "One of the chosen queues does not belong to this connection. Remove it and save again.",
  "backendErrors.ERR_PROMPT_QUEUE_CONFLICT": "One of the queues already has another agent on this connection. Each queue has at most one agent per connection.",
  "backendErrors.ERR_PROMPT_PREQUEUE_CONFLICT": "Another agent already answers before distribution on this connection. Uncheck the option or change the other agent.",
  "campaigns.smsEstimate.landlineSkipped": "{{count}} landline contact will be skipped for SMS (it does not receive SMS and uses no credit).",
  "campaigns.smsEstimate.landlineSkipped_plural": "{{count}} landline contacts will be skipped for SMS (they do not receive SMS and use no credit).",
  "contactListItems.numberType.landline": "Landline",
  "contactListItems.numberType.landlineHint": "Landline phone: skipped in SMS campaigns, still included in WhatsApp ones.",
};
